import { IAdvertRepository, ListAdvertsParams } from '../ports/IAdvertRepository';
import { AdvertEntity } from '../../domain/entities/Advert';

export interface ListAdvertsOutput { items: AdvertEntity[]; page: number; perPage: number; total: number; }

export class ListAdvertsUseCase {
  constructor(private repo: IAdvertRepository) {}
  async execute(params: ListAdvertsParams): Promise<ListAdvertsOutput> {
    const paginated = await this.repo.list(params);
    return { items: paginated.items, page: paginated.page, perPage: paginated.perPage, total: paginated.total };
  }
}
